import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Table, Button } from "reactstrap";
import { getApiUrl } from "../utils/site";

const PaymentHistory = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      setError(null);
  
      const token = localStorage.getItem("token"); // ✅ Get token from localStorage
      console.log("📌 Token Sent to Backend:", token); // 🔹 Debugging
  
      if (!token) {
        setError("❌ You must be logged in as an Admin to view payments.");
        setLoading(false);
        return;
      }
  
      try {
        const response = await axios.get(getApiUrl("/api/payments"), {
          headers: { Authorization: `Bearer ${token}` }, //  Send token correctly
        });
  
        setPayments(response.data);
      } catch (error) {
        console.error("❌ Error fetching payments:", error);
  
        if (error.response?.status === 400) {
          setError("❌ Bad Request: Invalid token or request.");
        } else if (error.response?.status === 401) {
          setError("❌ Unauthorized! Admin access required.");
        } else if (error.response?.status === 403) {
          setError("❌ Forbidden! You don't have permission.");
        } else {
          setError("❌ Failed to load payment history.");
        }
      } finally {
        setLoading(false);
      }
    };
  
    fetchPayments();
  }, []);
  
  
  if (loading) return <p>Loading payment history...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <Container>
      <h2 className="my-4">💰 Payment History</h2>
      <Table bordered>
        <thead>
          <tr>
            <th>#</th>
            <th>Customer</th>
            <th>Transaction ID</th>
            <th>Amount</th>
            <th>Method</th>
            <th>Status</th>
            <th>Receipt</th>
          </tr>
        </thead>
        <tbody>
          {payments.length > 0 ? (
            payments.map((payment, index) => (
              <tr key={payment.id}>
                <td>{index + 1}</td>
                <td>{payment.customer_name}</td>
                <td>{payment.transaction_id}</td>
                <td>${payment.amount}</td>
                <td>{payment.payment_method}</td>
                <td>
                  <span className={payment.status === "Completed" ? "text-success" : "text-warning"}>
                    {payment.status}
                  </span>
                </td>
                <td>
                  {payment.status === "Completed" ? (
                    <a
                      href={getApiUrl(`/api/payments/receipt/${payment.id}`)}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button color="primary" size="sm">📄 Download</Button>
                    </a>
                  ) : (
                    <span className="text-muted">Not Available</span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">No payments found.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default PaymentHistory;
